export const users = {
  ajay: '3feb97a4-96a0-449b-bfa2-f8884dad611b',
  research: '8f1465e8-ca50-4feb-b94c-88b0af4470d2',
}
